export const visit = (vm, at) => {
at({ "fr": { "priceComponents": { "pricePerMonth": "{{price}}/mois", "pricePerMonth_New": "{{price}} par mois", "pricePerMonthPerSeat": "{{price}}/mois/licence", "pricePerMonthPerSeat_New": "{{price}} par mois par licence", "subtexts": { "startsAt": "\xC0 partir de" } } } });
};